module.exports = __webpack_public_path__ + "img/about-cover.456e8c69.png";